'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ENGAGEMENT_ELEMENTS = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _tracking = require('@spp/tracking');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uiInternalLink = require('@spp/ui-internal-link');

var _uiInternalLink2 = _interopRequireDefault(_uiInternalLink);

var _props = require('../props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUBSCRIBE_BUTTON = 'subscribe';
var DEFAULT_SUBSCRIBE_LABEL = 'Subscribe';

var ENGAGEMENT_ELEMENTS = exports.ENGAGEMENT_ELEMENTS = {
    SUBSCRIBE: 'Masthead_Subscribe'
};

var subscribeButtonClick = function subscribeButtonClick(engagement, url, name) {
    return function (event) {
        event.preventDefault();

        _tracking.util.actionThenRelocateWithTimeout(engagement({
            elementIdentifier: ENGAGEMENT_ELEMENTS.SUBSCRIBE,
            meta: { name: name, event: event }
        }), url);
    };
};

var SubscribeButton = function SubscribeButton(_ref) {
    var _classNames;

    var theme = _ref.theme,
        mastheadExtension = _ref.mastheadExtension,
        engagement = _ref.engagement,
        focusable = _ref.focusable;
    var subscribeUrl = mastheadExtension.subscribeUrl,
        labels = mastheadExtension.labels,
        mastheadExtensionButton = mastheadExtension.button;

    var subscribeButtonClasses = (0, _classnames2.default)((_classNames = {}, (0, _defineProperty3.default)(_classNames, theme.root, true), (0, _defineProperty3.default)(_classNames, theme.enabledOnMobile, mastheadExtensionButton === SUBSCRIBE_BUTTON), (0, _defineProperty3.default)(_classNames, theme.hidden, !focusable), _classNames));

    var _labels$subscribe = labels.subscribe,
        subscribe = _labels$subscribe === undefined ? DEFAULT_SUBSCRIBE_LABEL : _labels$subscribe;


    return _react2.default.createElement(
        _uiInternalLink2.default,
        {
            link: subscribeUrl,
            className: subscribeButtonClasses,
            onClick: subscribeButtonClick(engagement, subscribeUrl, 'Subscribe'),
            enableSinglePage: true
        },
        subscribe
    );
};

if (process.env.NODE_ENV !== 'production') {
    SubscribeButton.propTypes = {
        engagement: _propTypes2.default.func,
        mastheadExtension: _propTypes2.default.shape(_props.mastheadExtensionProps).isRequired,
        theme: _propTypes2.default.shape({
            root: _propTypes2.default.string,
            enabledOnMobile: _propTypes2.default.string
        }),
        focusable: _propTypes2.default.bool
    };
}

SubscribeButton.defaultProps = {
    engagement: function engagement() {
        return _promise2.default.resolve();
    },
    theme: {},
    focusable: true
};

exports.default = SubscribeButton;
//# sourceMappingURL=SubscribeButton.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/lib/cjs/components/SubscribeButton/SubscribeButton.js
 ** module id = 333
 ** module chunks = 0
 **/